import React from 'react';
import "./EditStatus.scss";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {
    fetchUserStatus, updateUserStatus,
    USER_FIL_ACTUALITY_KEY,
    USER_STATUS_KEY
} from "../../../api/public-voissa/users";
import {PageLoader} from "../../components/Loader";
import InputPost from "../../components/InputPost";
import {STATUS} from "../../../const/toasts";
import {toastError} from "../../../libs/toast";
import {HOME_FEED_FOR_YOU_KEY} from "../../../api/public-voissa/home-feed";

const EditStatus = ({
        statusId = null,
        userId= null,
        handleClose = () =>{}
    }) =>{
    const queryClient = useQueryClient();

    const {isLoading : isLoadingStatus, data : dataStatus} = useQuery(
        [USER_STATUS_KEY, userId, statusId],
        ()=> fetchUserStatus(userId, statusId),
        {
            staleTime : 0,
            enabled : !!statusId,
        }
    );

    const {
        mutate : mutateUpdateStatus,
    } = useMutation((data) => updateUserStatus(userId, statusId, data),{
        onSuccess: async (data) =>{
            await queryClient.invalidateQueries([USER_STATUS_KEY, userId, statusId]);
            await queryClient.invalidateQueries([USER_FIL_ACTUALITY_KEY, userId]);
            await queryClient.invalidateQueries([HOME_FEED_FOR_YOU_KEY]);
            handleClose();
        },
        onError: () =>{
            toastError(STATUS.ERROR.DELETE);
        }
    });


    return (
        <div id="edit-status">
            <div className="card edit-status-publish-status">
                <div className="label">Editer le statut</div>
                {isLoadingStatus ? (
                    <PageLoader/>
                ) : (
                    <InputPost
                        sendBtn={true}
                        editorStyle={"edit-comment--draft"}
                        btnContent={"Editer le statut"}
                        emoji={true}
                        placeholder={`${dataStatus?.username}, écrivez ce que vous avez en tête ...`}
                        handleSubmit={(data) => mutateUpdateStatus(data)}
                        loading={isLoadingStatus}
                        contentRaw={dataStatus?.contentRaw}/>
                )}
            </div>
        </div>
    )
};

export default EditStatus;